import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { agentQuery } from 'src/api';
// import { companyInfo } from 'src/api';
import { message } from 'antd';
// import { MyStore, reducers } from 'kts-platform-frame/redux';
// import Message from 'kts-scaffold-framework/component/Message';

class ModulesAction extends ActionBasic<ModulesState> {
    // 已授权列
    public agented = async () => {
        const res = await agentQuery.agented(this);
        if (!res.er) {
            // console.log(res, 'res');
            this.modulesState.tableDataList = res.res as any;
            this.setModulesState();
        }
    }
    // 授权申请
    public agentApply = async () => {
        let params = {
            agentedId: '', //查询不传
            pageNum: 1,
            pageSize: 10
        };
        const res = await agentQuery.agentApply(this, params) as any;
        if (!res.er) {
            // console.log(res, 'res');
            this.modulesState.tableDataList = res.res&&res.res.items;
            // this.modulesState.tableDataList = [{
            //     name: 111,
            //     processStatus: 1,
            //     applyTime: '2020-05-18',
            //     operateTime: '2020-05-18',
            //     operateUserName: '刘官',
            // }];
            this.setModulesState();
        }
    }
    // 设置代理商查询
    public agentQueryFn = async (companyName) => {
        const res = await agentQuery.agentQueryFn(this, {companyName: companyName});
        if (!res.er) {
            // console.log(res, 'res');
            if(!res.res) {
                this.modulesState.agentNameHintErr = true;
            }else {
                this.modulesState.agentNameHintErr = false;
                this.modulesState.agentNameObj = res.res;
            }
            // this.modulesState.qualificationList = res.res;
            this.setModulesState();
        }
    }
    // 设置代理商
    public createAgent = async (obj) => {
        let params = {
            agentId: obj.companyId,
        };
        this.modulesState.confirmStatus = true;
        this.setModulesState();
        const res = await agentQuery.createAgent(this, params);
        this.modulesState.setAgentModalVisible = false;
        this.modulesState.setAgentvisible = false;
        this.modulesState.confirmStatus = false;
        this.setModulesState();
        if (!res.er) {
            // console.log(res, 'sssa');
            // this.modulesState.qualificationList = res.res;
            if(!res.res){
                message.error('设置失败');
            }else {
                message.success('设置成功');
            }
        }
    }
    // 取消授权代理商
    public cancelAgent = async (agentId) => {
        let params = {
            "agentId": agentId,
        };
        const res = await agentQuery.cancelAgent(this, params);
        if (!res.er) {
            if(!res.res){
                message.error('取消授权失败');
            }else{
                message.success('取消授权成功');
            }
            this.agented();
            // this.modulesState.qualificationList = res.res;
            this.setModulesState();
        }
    }
    // 同意 拒绝授权申请
    public handleRecordAgent = async (agentId, status) => {
        let params = {
            id: agentId,
            processStatus: status, // 1拒绝授权，2 同意授权
        };
        const res = await agentQuery.handleRecordAgent(this, params);
        if (!res.er) {
          if(status === 2) {
            if(!res.res){
                message.error('同意失败');
            }else{
                message.success('已同意');
            }
          }else if(status === 1) {
            if(!res.res){
              // message.error('拒绝失败');
            }else{
                message.success('已拒绝');
            }
          }
            this.agentApply();
            // this.modulesState.qualificationList = res.res;
            this.setModulesState();
        }
    }

}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/AgentAgree/Modules.Action.ts